define([
    'datePicker/subComponents/datePickerComp',
    'datePicker/subComponents/calendar',
    'datePicker/subComponents/month',
    'datePicker/subComponents/day',
    'skins',
    'datePicker/skins/skins.json',
    'componentsCore'
], function (datePicker, calendar, month, day, skinsPackage, skinsJson, componentsCore) {
    'use strict';

    const comps = {
        datePicker,
        calendar,
        month,
        day
    };

    componentsCore.compRegistrar
        .register('wysiwyg.viewer.components.inputs.DatePicker', comps.datePicker)
        .register('wysiwyg.viewer.components.Calendar', comps.calendar)
        .register('wysiwyg.viewer.components.Month', comps.month)
        .register('wysiwyg.viewer.components.Day', comps.day);

    skinsPackage.skinsMap.addBatch(skinsJson);

    return comps;
});
